// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ColorPicker_wrapper__2j5kY","box":"ColorPicker_box__3e8sf","selected":"ColorPicker_selected__gtjG9"};